const stripComments = code => {
  return code.replace(/\/\/.*$/gm, "").replace(/\/\*[\s\S]*?\*\//g, "")
}

/**
 * Parse filter code to extract data store keys from DataStore property assignments.
 * Detects patterns like: DataStore.key = value, DataStore["key"] = value, DataStore['key'] = value
 * Ignores assignments inside comments.
 * @param {string} filterCode - The filter code to parse
 * @returns {string[]} - Array of unique data store key names
 */
export const parseFilterCodeDataStore = (filterCode, maxKeys = 20) => {
  if (!filterCode) return []

  const codeWithoutComments = stripComments(filterCode)
  const keys = new Set()

  // Match DataStore.keyName = (dot notation assignment)
  const dotNotationRegex = /DataStore\.(\w+)\s*=/g
  for (const match of codeWithoutComments.matchAll(dotNotationRegex)) {
    keys.add(match[1])
    if (keys.size >= maxKeys) break
  }

  // Match DataStore["keyName"] = or DataStore['keyName'] = (bracket notation assignment)
  const bracketNotationRegex = /DataStore\[["']([^"']+)["']\]\s*=/g
  for (const match of codeWithoutComments.matchAll(bracketNotationRegex)) {
    if (keys.size >= maxKeys) break
    keys.add(match[1])
  }

  return Array.from(keys)
}
